"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verify = exports.AttributeValidationError = void 0;
const common_1 = require("../common");
var AttributeValidationError;
(function (AttributeValidationError) {
    AttributeValidationError["OUTSIDE_RANGE"] = "OUTSIDE_RANGE";
    AttributeValidationError["NOT_NUMBER"] = "NOT_NUMBER";
    AttributeValidationError["INVALID_MEMBERS"] = "INVALID_MEMBERS";
    AttributeValidationError["NOT_PRESENT"] = "NOT_PRESENT";
    AttributeValidationError["NOT_BOOLEAN"] = "NOT_BOOLEAN";
    AttributeValidationError["NOT_ARRAY"] = "NOT_ARRAY";
    AttributeValidationError["NOT_ENUM_VALUE"] = "NOT_ENUM_VALUE";
    AttributeValidationError["NOT_BITMAP_VALUE"] = "NOT_BITMAP_VALUE";
})(AttributeValidationError || (exports.AttributeValidationError = AttributeValidationError = {}));
exports.verify = 0x5a;
const attx = {
    attributeType: 'enumeration',
    enumeration: common_1.AppValueTypes,
};
